var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_8967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_8967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0039 22.0013V22.0213",
    stroke: "#00A266",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3496 16.7573C9.47236 16.0831 8.79865 15.1795 8.40289 14.1463C8.00712 13.1132 7.90472 11.9907 8.107 10.903C8.30927 9.81531 8.80835 8.80471 9.54907 7.98291C10.2898 7.16111 11.2433 6.56012 12.3042 6.24635C13.3652 5.93259 14.4922 5.91826 15.5607 6.20497C16.6293 6.49168 17.5978 7.06825 18.3591 7.87097C19.1205 8.67368 19.6451 9.67127 19.8749 10.7535C20.1048 11.8357 20.0309 12.9604 19.6616 14.0033",
    stroke: "#00A266",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0039 8.00128V15.6073C34.4792 17.0395 36.3637 19.3062 37.3199 22.0013H40.0019C40.5324 22.0013 41.0411 22.212 41.4161 22.5871C41.7912 22.9621 42.0019 23.4708 42.0019 24.0013V28.0013C42.0019 28.5317 41.7912 29.0404 41.4161 29.4155C41.0411 29.7906 40.5324 30.0013 40.0019 30.0013H37.3179C36.6459 31.9013 35.5039 33.6013 34.0019 34.9473V39.0013C34.0019 39.7969 33.6859 40.56 33.1233 41.1226C32.5606 41.6852 31.7976 42.0013 31.0019 42.0013C30.2063 42.0013 29.4432 41.6852 28.8806 41.1226C28.318 40.56 28.0019 39.7969 28.0019 39.0013V37.8353C27.341 37.946 26.6721 38.0015 26.0019 38.0013H18.0019C17.3318 38.0015 16.6628 37.946 16.0019 37.8353V39.0013C16.0019 39.7969 15.6859 40.56 15.1233 41.1226C14.5606 41.6852 13.7976 42.0013 13.0019 42.0013C12.2063 42.0013 11.4432 41.6852 10.8806 41.1226C10.318 40.56 10.0019 39.7969 10.0019 39.0013V35.0013V34.9473C8.18986 33.3272 6.91249 31.1951 6.3389 28.833C5.76531 26.471 5.92256 23.9904 6.78982 21.7197C7.65708 19.449 9.19346 17.4952 11.1956 16.1169C13.1977 14.7387 15.5712 14.0009 18.0019 14.0013H23.0019L32.0019 8.00128H32.0039Z",
    stroke: "#00A266",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill10);
export default __webpack_public_path__ + "static/media/bill-10.ab6b328c9e297f4713549961c67ea317.svg";
export { ForwardRef as ReactComponent };